import { render, staticRenderFns } from "./AddLabel.vue?vue&type=template&id=1e5ee50a&scoped=true&"
import script from "./AddLabel.vue?vue&type=script&lang=js&"
export * from "./AddLabel.vue?vue&type=script&lang=js&"
import style0 from "./AddLabel.vue?vue&type=style&index=0&id=1e5ee50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5ee50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e5ee50a')) {
      api.createRecord('1e5ee50a', component.options)
    } else {
      api.reload('1e5ee50a', component.options)
    }
    module.hot.accept("./AddLabel.vue?vue&type=template&id=1e5ee50a&scoped=true&", function () {
      api.rerender('1e5ee50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/components/ui/dropdown/AddLabel.vue"
export default component.exports